(() => {
  function init(root = document) {
    root.querySelectorAll('[data-club-section="booking"]').forEach(section => {
      const trigger = section.querySelector('[data-club-booking-open]');
      const dialog = section.querySelector('.club-booking-dialog');
      if (!trigger || !dialog || trigger.dataset.ready) return;
      trigger.dataset.ready = 'true';
      trigger.addEventListener('click', () => {
        if (!dialog.querySelector('iframe')) {
          const frame = document.createElement('iframe');
          const url = new URL(dialog.dataset.bookingUrl);
          url.searchParams.set('embed_domain', location.hostname);
          url.searchParams.set('embed_type', 'Inline');
          frame.title = 'Choose a time for your Fore2Feet club call';
          frame.src = url.href;
          dialog.querySelector('.club-booking-calendar').append(frame);
        }
        dialog.showModal();
      });
      dialog.querySelector('[data-club-booking-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => trigger.focus());
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
